import React, {Component} from 'react';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import classnames from 'classnames';
import {connect} from 'react-redux';
import {Link} from "react-router-dom";
import {Map} from "immutable";
import Modal from "@atlaskit/modal-dialog/dist/esm/components/Modal";

// Components
import CustomerDetail from "./CustomerDetail";
import CustomerQuotes from './CustomerQuotes';
import CustomerOrders from './CustomerOrders';
import CustomerIssues from './CustomerIssues';
import CustomerInvoices from './CustomerInvoices';
import CustomerFiles from "./CustomerFiles";
import DeleteDialog from '../../../components/dialogs/DeleteDialog';
import { paymentTypes } from '../../../components/common/payment-types';

// Actions
import {changeCustomerStatus, getCustomer, updateCustomer, uploadCustomerFiles, downloadCustomerFile, deleteCustomerFile, deleteCustomer} from "../../../actions/customers";

class CustomerTabs extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tabIndex: this.getSelectedIndex(),
            mode: 'view',
            canSubmit: false,
            customer_code: '',
            account_code: '',
            basic_info_name: '',
            basic_info_fiscal_id: '',
            basic_info_fiscal_name: '',
            basic_info_address: '',
            basic_info_postal_code: '',
            basic_info_city: '',
            basic_info_province: '',
            basic_info_country: '',
            basic_info_phone: '',
            basic_info_mobile_phone: '',
            basic_info_fax: '',
            basic_info_email: '',
            contact_person_name: '',
            contact_person_phone: '',
            contact_person_email: '',
            bank_info_name: '',
            bank_info_iban: '',
            bank_info_swift: '',
            payment_type: '',
            status: '',
            // modal
            modalIsOpen: false,
            modalType: null
        };

        this.getSelectedIndex = this.getSelectedIndex.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
    }

    componentDidMount() {
        const { customerId } = this.props.match.params;

        this.props.getCustomer(customerId);
    }

    componentDidUpdate(prevProps, prevState) {
        const { customer: prevCustomer } = prevProps;
        const { customer } = this.props;
        const { payment_type: prevPayment_type } = prevState;
        const { payment_type } = this.state;

        if (customer && customer !== prevCustomer) this.setCustomer(customer);

        if (payment_type !== prevPayment_type) {
            if (!paymentTypes.some(type => type.get('type_code') === payment_type)) {
                this.setState({ payment_type: -1 });
            }
        }
    }

    // Tab functions
    getSelectedIndex() {
        const {customerId} = this.props.match.params;

        // Check if any child route is active. As last step, check if principal route is active to assign default tab index.
        switch (this.props.history.location.pathname) {
            case '/ventas/clientes/' + customerId + '/detalle':
                return 0;
            case '/ventas/clientes/' + customerId + '/presupuestos':
                return 1;
            case '/ventas/clientes/' + customerId + '/pedidos':
                return 2;
            case '/ventas/clientes/' + customerId + '/albaranes':
                return 3;
            case '/ventas/clientes/' + customerId + '/facturas':
                return 4;
            case '/ventas/clientes/' + customerId + '/ficheros':
                return 5;
            default:
                return 0;
        }
    }
    handleTabChange(index, lastIndex, event) {
        const {customerId} = this.props.match.params;
        let route = '';

        switch (index) {
            case 0:
                route = '/ventas/clientes/' + customerId + '/detalle';
                break;
            case 1:
                route = '/ventas/clientes/' + customerId + '/presupuestos';
                break;
            case 2:
                route = '/ventas/clientes/' + customerId + '/pedidos';
                break;
            case 3:
                route = '/ventas/clientes/' + customerId + '/albaranes';
                break;
            case 4:
                route = '/ventas/clientes/' + customerId + '/facturas';
                break;
            case 5:
                route = '/ventas/clientes/' + customerId + '/ficheros';
                break;
            default:
                break;
        }

        this.props.history.push(route);
        this.setState({
            tabIndex: this.getSelectedIndex()
        });
    }

    // CustomerDetail functions
    handleEditClick = () => {
        this.setState({
            mode: 'edit'
        });
    };
    handleCancelClick = () => {
        const { customer } = this.props;

        this.setCustomer(customer);
        this.setState({
            mode: 'view',
            canSubmit: false
        });
    };
    handleSaveClick = (customerId, customer) => {
        this.props.updateCustomer(customerId, customer);
        this.setState({
            mode: 'view'
        });
    };
    onChangeInput = (inputName, inputValue) => {
        this.setState({
            [inputName]: inputValue
        }, this.validateCustomer);
    };
    setCustomer = (customer) => {
        this.setState({
            customer_code: customer.get('customer_code') || '',
            account_code: customer.get('account_code') || '',
            basic_info_name: customer.getIn(['basic_info', 'name']) || '',
            basic_info_fiscal_id: customer.getIn(['basic_info', 'fiscal_id']) || '',
            basic_info_fiscal_name: customer.getIn(['basic_info', 'fiscal_name']) || '',
            basic_info_address: customer.getIn(['basic_info', 'address']) || '',
            basic_info_postal_code: customer.getIn(['basic_info', 'postal_code']) || '',
            basic_info_city: customer.getIn(['basic_info', 'city']) || '',
            basic_info_province: customer.getIn(['basic_info', 'province']) || '',
            basic_info_country: customer.getIn(['basic_info', 'country']) || '',
            basic_info_phone: customer.getIn(['basic_info', 'phone']) || '',
            basic_info_mobile_phone: customer.getIn(['basic_info', 'mobile_phone']) || '',
            basic_info_fax: customer.getIn(['basic_info', 'fax']) || '',
            basic_info_email: customer.getIn(['basic_info', 'email']) || '',
            contact_person_name: customer.getIn(['contact_person', 'name']) || '',
            contact_person_phone: customer.getIn(['contact_person', 'phone']) || '',
            contact_person_email: customer.getIn(['contact_person', 'email']) || '',
            bank_info_name: customer.getIn(['bank_info', 'name']) || '',
            bank_info_iban: customer.getIn(['bank_info', 'iban']) || '',
            bank_info_swift: customer.getIn(['bank_info', 'swift']) || '',
            payment_type: customer.get('payment_type') || -1,
            status: customer.get('status')
        }, () => this.validateCustomer);
    };
    validateCustomer = () => {
        if (
            this.state.account_code !== '' &&
            this.state.basic_info_name !== '' &&
            this.state.basic_info_fiscal_id !== '' &&
            this.state.basic_info_fiscal_name !== '' &&
            this.state.basic_info_address !== '' &&
            this.state.basic_info_postal_code !== '' &&
            this.state.basic_info_city !== '' &&
            this.state.basic_info_province !== '' &&
            this.state.basic_info_country !== '' &&
            this.state.contact_person_name !== '' &&
            this.state.bank_info_name !== '' &&
            this.state.payment_type !== -1
        ) {
            this.setState({
                canSubmit: true
            });
        } else {
            this.setState({
                canSubmit: false
            });
        }
    };

    // Modal handlers
    openModal = (modalType) => {
        this.setState({
            modalType,
            modalIsOpen: true
        });
    };
    closeModal = () => {
        this.setState({
            modalType: null,
            modalIsOpen: false
        })
    };

    render() {
        const {customerId} = this.props.match.params;
        const { customer } = this.props;
        const {
            tabIndex,
            mode,
            canSubmit,
            customer_code,
            account_code,
            basic_info_name,
            basic_info_fiscal_id,
            basic_info_fiscal_name,
            basic_info_address,
            basic_info_postal_code,
            basic_info_city,
            basic_info_province,
            basic_info_country,
            basic_info_phone,
            basic_info_mobile_phone,
            basic_info_fax,
            basic_info_email,
            contact_person_name,
            contact_person_phone,
            contact_person_email,
            bank_info_name,
            bank_info_iban,
            bank_info_swift,
            payment_type,
            status
        } = this.state;

        // Modal Area
        let modal = null;
        if (this.state.modalIsOpen) {
            switch (this.state.modalType) {
                case 'deleteDialog':
                    modal = {
                        width: 'medium',
                        title: 'Borrar cliente',
                        body: (
                            <DeleteDialog
                                text={ this.props.customer.get('customer_code') }
                            />
                        ),
                        footer: (
                            <div className="modal-footer">
                                <button
                                    key="cancel"
                                    type="button"
                                    className="btn btn-cancel"
                                    label={'Cancelar'}
                                    style={{
                                        color: 'gray',
                                        marginRight: 15
                                    }}
                                    onClick={this.closeModal}
                                >
                                    {'Cancelar'}
                                </button>
                                <button
                                    key="delete"
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={ () => {
                                        this.props.deleteCustomer(this.props.customer.get('_id'));
                                        this.closeModal();
                                        this.props.history.push('/ventas/clientes');
                                    }}
                                >
                                    {'Borrar'}
                                </button>
                            </div>
                        )
                    };
                    break;
                default:
                    modal = {
                        title: '',
                        body: null,
                        footer: null
                    };
                    break;
            }
        }

        return (

            <div id="page-wrapper" className="gray-bg">
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col d-flex align-items-center">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/ventas/resumen">Ventas</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to="/ventas/clientes">Clientes</Link>
                            </li>
                            <li className="breadcrumb-item active">
                                <strong>{ `[${customer_code}] ${basic_info_name}` }</strong>
                            </li>
                        </ol>
                    </div>
                    { tabIndex === 0
                        ? (
                            <div className="col d-flex align-items-center justify-content-end">
                                {mode === 'view'
                                    ? <div className="title-action">
                                        {
                                            customer.get('can_delete')
                                                ? <button className="btn btn-danger" onClick={ () => this.openModal('deleteDialog') }>Borrar</button>
                                                : null
                                        }
                                        <button className="btn btn-custom" onClick={this.handleEditClick}>Editar</button>
                                    </div>
                                    : <div className="title-action">
                                        <button className="btn btn-cancel" onClick={this.handleCancelClick}>Cancelar</button>
                                        <button
                                            className="btn btn-primary"
                                            onClick={ () => this.handleSaveClick(customerId, {
                                                customer_code,
                                                account_code,
                                                basic_info: {
                                                name: basic_info_name,
                                                fiscal_id: basic_info_fiscal_id,
                                                fiscal_name: basic_info_fiscal_name,
                                                address: basic_info_address,
                                                postal_code: basic_info_postal_code,
                                                city: basic_info_city,
                                                province: basic_info_province,
                                                country: basic_info_country,
                                                phone: basic_info_phone,
                                                mobile_phone: basic_info_mobile_phone,
                                                fax: basic_info_fax,
                                                email: basic_info_email
                                            },
                                                contact_person: {
                                                name: contact_person_name,
                                                phone: contact_person_phone,
                                                email: contact_person_email
                                            },
                                                bank_info: {
                                                name: bank_info_name,
                                                iban: bank_info_iban,
                                                swift: bank_info_swift
                                            },
                                                payment_type
                                            }) }
                                            disabled={!canSubmit}
                                        >Guardar
                                        </button>
                                    </div>
                                }
                            </div>
                        ) : ''
                    }
                </div>
                <div className="wrapper wrapper-content">
                    <div className="row">
                        <div className="col">
                            <div className="tabs-container">
                                <Tabs
                                    selectedIndex={tabIndex}
                                    onSelect={this.handleTabChange}
                                    selectedTabPanelClassName="active show"
                                >
                                    <TabList className="nav nav-tabs">
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 0})}>Detalle</Link>
                                        </Tab>
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 1})}>Presupuestos</Link>
                                        </Tab>
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 2})}>Pedidos</Link>
                                        </Tab>
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 3})}>Albaranes</Link>
                                        </Tab>
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 4})}>Facturas</Link>
                                        </Tab>
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 5})}>Ficheros</Link>
                                        </Tab>
                                    </TabList>
                                    <div className="tab-content">
                                        <TabPanel className="tab-pane">
                                            <div className="panel-body">
                                                <CustomerDetail
                                                    mode={mode}
                                                    onChangeInput={ this.onChangeInput }
                                                    onChangeCountry={ this.onChangeCountry }
                                                    onChangeProvince={ this.onChangeProvince }
                                                    customer={{
                                                        _id: this.props.match.params.customerId,
                                                        customer_code,
                                                        account_code,
                                                        basic_info_name,
                                                        basic_info_fiscal_id,
                                                        basic_info_fiscal_name,
                                                        basic_info_address,
                                                        basic_info_postal_code,
                                                        basic_info_city,
                                                        basic_info_province,
                                                        basic_info_country,
                                                        basic_info_phone,
                                                        basic_info_mobile_phone,
                                                        basic_info_fax,
                                                        basic_info_email,
                                                        contact_person_name,
                                                        contact_person_phone,
                                                        contact_person_email,
                                                        bank_info_name,
                                                        bank_info_iban,
                                                        bank_info_swift,
                                                        payment_type,
                                                        status
                                                    }}
                                                    paymentTypes={paymentTypes}
                                                    changeCustomerStatus={this.props.changeCustomerStatus}
                                                />
                                            </div>
                                        </TabPanel>
                                        <TabPanel className="tab-pane">
                                            { this.props.customer.get('_id')
                                                ? <CustomerQuotes
                                                    customerId={this.props.customer.get('_id')}
                                                    status={this.props.customer.get('status')}
                                                    history={this.props.history}
                                                /> : null
                                            }
                                        </TabPanel>
                                        <TabPanel className="tab-pane">
                                            { this.props.customer.get('_id')
                                                ? <CustomerOrders
                                                    customerId={this.props.match.params.customerId}
                                                    status={this.props.customer.get('status')}
                                                    history={this.props.history}
                                                />
                                                : null
                                            }
                                        </TabPanel>
                                        <TabPanel className="tab-pane">
                                            { this.props.customer.get('_id')
                                                ? <CustomerIssues
                                                    customerId={this.props.match.params.customerId}
                                                    status={this.props.customer.get('status')}
                                                    history={this.props.history}
                                                /> : null
                                            }
                                        </TabPanel>
                                        <TabPanel className="tab-pane">
                                            { this.props.customer.get('_id')
                                                ? <CustomerInvoices
                                                    customerId={this.props.match.params.customerId}
                                                    status={this.props.customer.get('status')}
                                                    history={this.props.history}
                                                /> : null
                                            }
                                        </TabPanel>
                                        <TabPanel className="tab-pane">
                                            { this.props.customer.get('_id')
                                                ? <CustomerFiles
                                                    customer={this.props.customer}
                                                    uploadCustomerFiles={this.props.uploadCustomerFiles}
                                                    uploadProgress={this.props.uploadProgress}
                                                    downloadCustomerFile={this.props.downloadCustomerFile}
                                                    deleteCustomerFile={this.props.deleteCustomerFile}
                                                    addNotification={this.props.addNotification}
                                                /> : null
                                            }
                                        </TabPanel>
                                    </div>
                                </Tabs>
                            </div>
                        </div>
                    </div>
                </div>
                { this.state.modalIsOpen && (
                    <Modal
                        width={modal.width}
                        heading={modal.title}
                        footer={() => modal.footer}
                        autoFocus={false}
                        onClose={this.closeModal}
                    >
                        {modal.body}
                    </Modal>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    // Reducers
    const customerReducer = state.customers;

    // Customer
    const customer = customerReducer.get('payload') || Map({});

    // Upload Progress
    const uploadProgress = Map({
        isUploading: customerReducer.get('isUploading') || false,
        percent: customerReducer.get('percent') || 0
    });

    return {
        customer,
        uploadProgress
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getCustomer: (customerId) => dispatch(getCustomer(customerId)),
        updateCustomer: (customerId, customer) => dispatch(updateCustomer(customerId, customer)),
        changeCustomerStatus: (customerId, status) => dispatch(changeCustomerStatus(customerId, status)),
        uploadCustomerFiles: (customerId, files) => dispatch(uploadCustomerFiles(customerId, files)),
        downloadCustomerFile: (customerId, fileId) => dispatch(downloadCustomerFile(customerId, fileId)),
        deleteCustomerFile: (customerId, fileId) => dispatch(deleteCustomerFile(customerId, fileId)),
        deleteCustomer: (customerId) => dispatch(deleteCustomer(customerId))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerTabs);



// WEBPACK FOOTER //
// ./src/containers/sales/customers/CustomerTabs.js